/// <reference path="../generated/MitgliedschaftAnlageResponseApi.d.ts"/>
import { MglApiResponseDataModel } from '../api/MglApiData';
import { BankverbindungApi } from '../generated/PersonBankverbindungApi';
import { AntragsstellerApi } from '../generated/MitgliedschaftAntragsstellerApi';
import { AppUtils } from '../../utils/index';
/**
 * Model for transferring customer data from the membership form application (1-stufigen) to the calling application.
 */
export class MglCustomerModel {
	private _membership: number;
	private targetApplicationName: string;
	private hatAbweichendenKontoInhaber: boolean;
	private _dob: string;
	private bankdaten: BankverbindungApi;
	private antragssteller: AntragsstellerApi;
	private _apiData: AnlageResponseApi;

	constructor() {
		this._apiData = new MglApiResponseDataModel();
		this.antragssteller = new AntragsstellerApi();
		this.bankdaten = new BankverbindungApi();
	}

	/**
	 * @return mgl response api data.
	 */
	get apiData(): AnlageResponseApi {
		return this._apiData;
	}

	/**
	 * @param value mgl response api data.
	 */
	set apiData(value: AnlageResponseApi) {
		this._apiData = value;
	}

	/**
	 * @return the customer data as entered on the membership form.
	 */
	get Antragssteller(): AntragsstellerApi {
		return this.antragssteller;
	}

	/**
	 * @param value the customer data as entered on the membership form.
	 */
	set Antragssteller(value: AntragsstellerApi) {
		this.antragssteller = value;
	}

	/**
	 * Date of birth / birthday.
	 *
	 * @return date string with format "dd.MM.yyyy".
	 */
	get dob(): string {
		return this._dob;
	}

	/**
	 * Date of birth / birthday.
	 *
	 * @param value date string with format "dd.MM.yyyy".
	 */
	set dob(value: string) {
		this._dob = value;
	}

	/**
	 * Flag, whether the user selected that the account owner differs from the ensurance applicant.
	 *
	 * @return true, if account owner differs, false otherwise.
	 */
	get HatAbweichendenKontoInhaber(): boolean {
		return this.hatAbweichendenKontoInhaber;
	}

	/**
	 * Flag, whether the user selected that the account owner differs from the ensurance applicant.
	 *
	 * @param value true, if account owner differs, false otherwise.
	 */
	set HatAbweichendenKontoInhaber(value: boolean) {
		this.hatAbweichendenKontoInhaber = value;
	}

	/**
	 * @returnaccount data.
	 */
	get Bankdaten(): BankverbindungApi {
		return this.bankdaten;
	}

	/**
	 * @param value account data.
	 */
	set Bankdaten(value: BankverbindungApi) {
		this.bankdaten = value;
	}

	/**
	 * @return the name of the application this customer data is intended for.
	 */
	get TargetApplicationName(): string {
		return this.targetApplicationName;
	}

	/**
	 * @param value the name of the application this customer data is intended for.
	 */
	set TargetApplicationName(value: string) {
		this.targetApplicationName = value;
	}

	/**
	 * The membership (BASIS / PLUS) the customer enclosed.
	 *
	 * @return 1 for BASIS membership, 2 for PLUS membership.
	 */
	get membership(): number {
		return this._membership;
	}

	/**
	 * The membership (BASIS / PLUS) the customer enclosed.
	 *
	 * @param value 1 for BASIS membership, 2 for PLUS membership.
	 */
	set membership(value: number) {
		this._membership = value;
	}

	/**
	 * @return true, if the mgl customer holds valid data.
	 * 					 false, if the mgl customer is empty.
	 */
	get Valid(): boolean {
		return !!this.targetApplicationName && !!this._apiData && !!this.antragssteller && !!this.bankdaten;
	}

	public toString(): string {
		return JSON.stringify(this);
	}

	/**
	 * Creates a new AbweichenderKontoInhaber object and copies the values from the provided data object (or other AbweichenderKontoInhaber model) to the created AbweichenderKontoInhaber.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MglCustomerModel {
		return AppUtils.Helper.createFromMap(dataObject, MglCustomerModel, (key: string, value: any) => {
			switch (key) {
				case '_apiData':
				case 'apiData':
					return MglApiResponseDataModel.createFromObject(value);
				case 'antragssteller':
				case 'Antragssteller':
					return AntragsstellerApi.createFromObject(value);
				case 'bankdaten':
				case 'Bankdaten':
					return BankverbindungApi.createFromObject(value);
				default:
					return value;
			}
		});
	}
}